var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#0D3688"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33008 12.5322C9.32552 12.3682 9.32324 12.2451 9.32324 12.1631C9.32324 11.68 9.3916 11.263 9.52832 10.9121C9.62858 10.6478 9.79036 10.3812 10.0137 10.1123C10.1777 9.91634 10.4717 9.63151 10.8955 9.25781C11.3239 8.87956 11.6019 8.57878 11.7295 8.35547C11.8571 8.13216 11.9209 7.88835 11.9209 7.62402C11.9209 7.14551 11.734 6.72624 11.3604 6.36621C10.9867 6.00163 10.5286 5.81934 9.98633 5.81934C9.46224 5.81934 9.02474 5.9834 8.67383 6.31152C8.32292 6.63965 8.09277 7.15234 7.9834 7.84961L6.71875 7.69922C6.83268 6.76497 7.16992 6.04948 7.73047 5.55273C8.29557 5.05599 9.04069 4.80762 9.96582 4.80762C10.9456 4.80762 11.7272 5.07422 12.3105 5.60742C12.8939 6.14062 13.1855 6.78548 13.1855 7.54199C13.1855 7.97949 13.083 8.38281 12.8779 8.75195C12.6729 9.12109 12.2718 9.56999 11.6748 10.0986C11.2738 10.4541 11.0117 10.7161 10.8887 10.8848C10.7656 11.0534 10.6745 11.2471 10.6152 11.4658C10.556 11.6846 10.5218 12.04 10.5127 12.5322H9.33008ZM9.25488 15V13.5986H10.6562V15H9.25488Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpActive);
export default __webpack_public_path__ + "static/media/help_active.e9a08618524a74b717981b6f110c042b.svg";
export { ForwardRef as ReactComponent };